<div class="flex items-center justify-end">
  <div class="text-sm leading-6">
    <a (click)="linkedClicked()" class="font-semibold text-cool-blue hover:underline cursor-pointer">{{ linktext }}</a>
  </div>
</div>
